import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const TAX_RATE_SAVED = gql`
  subscription taxRateSaved {
    taxRateSaved {
      id
      code
      description
      percent
      category
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const TAX_RATE_DELETED = gql`
  subscription taxRateDeleted {
    taxRateDeleted {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
